import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { Listings } from 'containers/AppContainer/typings';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import JudgementOnMerits from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits';
import { get } from 'lodash';
export interface JudgementOnMeritsAppealFormProps {
  intl: IntlShape;
  listings: Listings;
  policyInfo: any;
  judgementAddDocuments: any;
  judgementOnMerits: any;
  claimId: number;
  claimNumber: string;
  uploadDocument: Function;
  uploadedDocument: IUploadedDocument;
  resetUploadDocumentStore: Function;
  documentId: any;
  setDocumentId: Function;
  judgementOnMeritsInfo: any;
  setJudgementOnMeritsInfo: any;
  procedureNatureId: any;
  judgementAdd: any;
  procedureInstance: any;
  victims: any;
  vehicules: any;
  expertReport: any;
  requestGetDocByDocumentumId: Function;
}

export const JudgementOnMeritsAppealForm: React.FC<JudgementOnMeritsAppealFormProps> = (
  props,
): JSX.Element => {
  return (
    <JudgementOnMerits
      judgementAdd={props.judgementAdd}
      civilProceeding={[]}
      listings={props.listings}
      judgementAddClone={props.procedureInstance}
      claimId={props.claimId}
      claimNumber={props.claimNumber}
      judgementAddDocuments={props.judgementAddDocuments}
      requestCreateJudgementOnMerits={() => {}}
      uploadDocument={props.uploadDocument}
      uploadedDocument={props.uploadedDocument}
      resetUploadedDocument={props.resetUploadDocumentStore}
      documentId={props.documentId}
      setDocumentId={props.setDocumentId}
      judgementOnMerits={props.judgementOnMerits}
      requestGetDahirAmount={() => {}}
      dahirAmount={[]}
      policyInfo={props.policyInfo}
      judiciaryProcessId={get(props.procedureInstance, 'judiciaryProcessId')}
      isManager={false}
      isCivilProceeding={false}
      requestInsertDahirAmountJom={() => {}}
      requestGetDahirAmountCorpo={() => {}}
      dahirAmountsCorpo={{}}
      victims={props.victims}
      requestAddJudgementOnMeritsSupportDocument={() => {}}
      requestValidateJudgementOnMerits={() => {}}
      vehicules={props.vehicules}
      currentJudiciaryProcess={props.procedureInstance}
      sagisVictimInfo={[]}
      sagisOpposingParties={[]}
      expertiseReport={props.expertReport}
      isAssignedLawyer
      imagineDocuments={[]}
      isConsultation={false}
      requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
    />
  );
};

export default injectIntl(JudgementOnMeritsAppealForm);
